// extracted by mini-css-extract-plugin
var _1 = "ComingSoon_flex__GKHlF";
var _2 = "ComingSoon_footer__Kg1iV";
export { _1 as "flex", _2 as "footer" }
